(function () {
    'use strict';

    function workflowNavigatorController($scope, $rootScope, $timeout, $state, $window, $log,
        sessionData, entitySearches, milestones, phaseThumbnails,
        scrollingService, workflowStateService, milestoneModalService, workflowThumbnailsService,
        workflowConfigurationDataService, notifyService, toastr, hlStickyStack, $pbService) {
        var vm = this;
        vm.mode = 'Editor';
        vm.items = [
            { name: '1' },
            { name: '2' }
        ];

        vm.phaseThumbnails = phaseThumbnails;
        vm.sessionEntity = sessionData.Entity;
        vm.workflowData = workflowStateService.get();
        vm.filteredPhases = [];
        setFilteredPhases();
        vm.workflowId = vm.workflowData.Id.split('/')[1];
        vm.currentPhaseIndex = $rootScope.$state.params.phaseIndex || 1;
        updateNavigationStates();
        updateProgressCircles();
        vm.routePhaseIndex = 1;
        vm.isAddingInformationPart = false;
        vm.isAddingRequiredDownload = false;

        vm.allowSearchEditing = sessionData.EntityType === 'Portal Administrator';
        vm.currentPhaseHasRequiredDownloads = currentPhaseHasRequiredDownloads();
        vm.currentPhaseHasNotes = currentPhaseHasNotes();

        vm.tinymceOptions = {
          height: "144px",
          menubar: false,
          statusbar: false,
          resize: false,
          plugins: [
              "advlist autolink link paste"
          ],
          advlist_bullet_styles: "disc",
          toolbar: "undo redo | bold italic | bullist | link",
          valid_elements: '*[*]',
          debounce: true
        };

        vm.toggleEditPhaseHeaderCopy = function () {
            vm.isEditingHeaderCopy = !vm.isEditingHeaderCopy;

            if (vm.isEditingHeaderCopy) {
                vm.activateEditPhaseHeaderCopy();
            }
        }

        vm.activateEditPhaseHeaderCopy = function () {
            var index = vm.routePhaseIndex - 1;
            if (!vm.workflowData.Phases[index].HeaderCopyHtmlOverride &&
                !vm.workflowData.Phases[index].HeaderCopyHtmlTemplateId) {
                vm.workflowData.Phases[index].HeaderCopyHtmlOverride = 'Please complete the information below';
                vm.workflowData.Phases[index].OriginalHeaderCopyHtmlOverride = null;
                vm.workflowData.Phases[index].isEditingHeaderCopy = true;
            }
            else if (vm.workflowData.Phases[index].HeaderCopyHtmlOverride) {
                vm.workflowData.Phases[index].OriginalHeaderCopyHtmlOverride =
                    vm.workflowData.Phases[index].HeaderCopyHtmlOverride;
                vm.workflowData.Phases[index].isEditingHeaderCopy = true;
            }
            else {
                workflowConfigurationDataService.loadHtmlTemplate(
                    vm.workflowData.Phases[index].HeaderCopyHtmlTemplateId).then(function (data) {
                        vm.workflowData.Phases[index].HeaderCopyHtmlOverride = data.Html;
                        vm.workflowData.Phases[index].OriginalHeaderCopyHtmlOverride = data.Html;
                        vm.workflowData.Phases[index].isEditingHeaderCopy = true;
                    });
            }
        }

        vm.closeEditPhaseHeaderCopy = function (save) {
            vm.isEditingHeaderCopy = false;
            var index = vm.routePhaseIndex - 1;
            if (!save) {
                vm.workflowData.Phases[index].HeaderCopyHtmlOverride =
                    vm.workflowData.Phases[index].OriginalHeaderCopyHtmlOverride;
            }
            else {
                workflowStateService.update(vm.workflowData);
            }

            $rootScope.$emit('roadmapHtmlTemplateLoaded',
            {
                triggerMatchData: vm.workflowData.Phases[index]
                    .HeaderCopyHtmlTemplateId
            });
        }

        var partnerPopoverClass = 'partner-selector-popover';
        vm.navigatorPartnersPopoverConfig = {
            id: 'navigatorPhasePartners',
            class: partnerPopoverClass,
            placement: 'left',
            template: 'workflow/templates/partnerSelectorPopover.html',
            outsideSelector: 'div.' + partnerPopoverClass,
            outsideIgnoreSelector: 'button.' + partnerPopoverClass
        }

        vm.setInformationPartPopovers = function () {
            vm.workflowData.Phases[vm.currentPhaseIndex - 1].InformationParts.forEach(function (informationPart, index) {
                var partnerPopoverClass = 'information-part-partner-selector-popover' + index;
                informationPart.popoverConfig = {
                    id: 'informationPartPartners' + index,
                    class: 'partner-selector-popover ' + partnerPopoverClass,
                    placement: 'left',
                    template: 'workflow/templates/partnerSelectorPopover.html',
                    outsideSelector: 'div.' + partnerPopoverClass,
                    outsideIgnoreSelector: 'button.' + partnerPopoverClass
                }

                if (informationPart.BlobSummaries)
                {
                    informationPart.BlobSummaries.forEach(function (blobSummary, blobIndex) {
                        var blobSummaryCommentPopoverClass = 'blob-summary-comments-menu-popover-' + index + '-' + blobIndex;
                        blobSummary.popoverConfig = {
                            id: 'blobComments' + index + '_' + blobIndex,
                            class: 'comments-menu-popover ' + blobSummaryCommentPopoverClass,
                            placement: 'bottom',
                            template: 'workflow/templates/commentsMenuPopover.html',
                            outsideSelector: 'div.' + blobSummaryCommentPopoverClass,
                            outsideIgnoreSelector: 'button.' + blobSummaryCommentPopoverClass
                        }
                    }); 
                }

                if (informationPart.RequiredDownloads)
                {
                    informationPart.RequiredDownloads.forEach(function (requiredDownload, index) {
                        var requiredDownloadCommentPopoverClass = 'required-download-comments-menu-popover-' + index;
                        requiredDownload.popoverConfig = {
                            id: 'requiredDownloadComments' + index,
                            class: 'comments-menu-popover ' + requiredDownloadCommentPopoverClass,
                            placement: 'bottom',
                            template: 'workflow/templates/commentsMenuPopover.html',
                            outsideSelector: 'div.' + requiredDownloadCommentPopoverClass,
                            outsideIgnoreSelector: 'button.' + requiredDownloadCommentPopoverClass
                        }
                    });
                }
            });
        }

        vm.setInformationPartPopovers();

        $rootScope.$on('thumbnailsChanged', function (event, args) {
            try {
                workflowThumbnailsService.getThumbnails(vm.workflowId, vm.workflowData).then(function (data) {
                    Object.keys(data).forEach(function (key) {
                        if (!vm.phaseThumbnails[key]) {
                            vm.phaseThumbnails[key] = data[key];
                        }
                    });
                });
                $scope.$apply();
            } catch (error) {
                $log.warn('failed to replace thumbnails');
                $log.warn(error);
            }
        });

        $scope.$on('fileUploaded', function (event, args) {
            var newWorkflowData = workflowStateService.get();
            newWorkflowData.Phases[vm.currentPhaseIndex - 1].InformationParts.forEach(function (informationPart, index) {
                if (informationPart.BlobSummaries)
                {
                    informationPart.BlobSummaries.forEach(function (blobSummary, blobIndex) {
                        var blobSummaryCommentPopoverClass = 'blob-summary-comments-menu-popover-' + index + '-' + blobIndex;
                        blobSummary.popoverConfig = {
                            id: 'blobComments' + index + '_' + blobIndex,
                            class: 'comments-menu-popover ' + blobSummaryCommentPopoverClass,
                            placement: 'bottom',
                            template: 'workflow/templates/commentsMenuPopover.html',
                            outsideSelector: 'div.' + blobSummaryCommentPopoverClass,
                            outsideIgnoreSelector: 'button.' + blobSummaryCommentPopoverClass
                        }
                    });
                }
            });
        });

        // get the default stack instance
        var stack = hlStickyStack();
        var clientY;
        angular.forEach(['mousemove', 'scroll'], function(eventName) {
            angular.element($window).bind(eventName, function updateStackVariables(event) {
            if (angular.isDefined(event.clientY)) {
                clientY = event.clientY;
            }
            var mousePosition = clientY + window.pageYOffset;

            // get the current total height of the stack
            $scope.stackHeightCurrent = stack.heightCurrent('top');

            // get the total height of the stack at the position of the mouse
            $scope.stackHeightAtPosition = stack.heightAt('top', mousePosition);

            // trigger a scope digest because the event wasn't from Angular
            $scope.$apply();
            });
        });

        if (vm.allowSearchEditing) {
            vm.entitySearches = entitySearches;
        }

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        function setFilteredPhases() {
            vm.filteredPhases = [];
            vm.workflowData.Phases.forEach(function (phase, index) {
                if (phase.Access.View) {
                    vm.filteredPhases.push({
                        Title: phase.Title,
                        Index: index,
                        PercentageComplete: phase.PercentageComplete
                    });
                }
            });
        }

        function currentPhaseHasRequiredDownloads() {
            return vm.workflowData.Phases[vm.currentPhaseIndex - 1].InformationParts.some(function (informationPart) {
                return informationPart.RequiredDownloads &&
                    informationPart.RequiredDownloads.filter(
                    function (download) {
                        return !download.IsRemoved &&
                            download.BlobSummary &&
                            download.BlobSummary.BlobReference
                    }).length > 0;
                });
        }

        function currentPhaseHasNotes() {
            return (vm.workflowData.Phases[vm.currentPhaseIndex - 1].ProjectUnderwritingNotes.some(function (note) {
                return !note.IsRemoved
            }) && vm.workflowData.Phases[vm.currentPhaseIndex - 1].Access.Notes) || vm.isAddingNote;
        }

        function updateNavigationStates() {
            vm.canNavigateForward = vm.workflowData.Phases.length > vm.currentPhaseIndex &&
                vm.workflowData.Phases.slice(vm.currentPhaseIndex).find(function (phase) {
                    return phase.Access.View && !phase.IsRemoved;
                });

            vm.canNavigateBackward = vm.currentPhaseIndex > 1 &&
                vm.workflowData.Phases.slice(0, vm.currentPhaseIndex - 1).find(function (phase) {
                    return phase.Access.View && !phase.IsRemoved;
                });
        }

        function updateProgressCircles() {
            $timeout(function () {
                var phasePercentageComplete = vm.workflowData.Phases[vm.currentPhaseIndex - 1].PercentageComplete / 100;
                $pbService.animate('topProgressCircle', phasePercentageComplete);
                $pbService.animate('navProgressCircle', phasePercentageComplete);
                $pbService.animate('topProgressCircleSkipped', phasePercentageComplete);
                $pbService.animate('navProgressCircleSkipped', phasePercentageComplete);
            })
        };

        vm.toggleAddNote = function () {
            vm.isAddingNote = !vm.isAddingNote;
            vm.currentPhaseHasNotes = currentPhaseHasNotes();
        }

        $rootScope.$on('cancelledAddComment', function (event, args) {
            if (args.path === vm.workflowData.Phases[vm.currentPhaseIndex - 1].Path) {
                vm.isAddingNote = false;
                vm.currentPhaseHasNotes = currentPhaseHasNotes();
            }
        });

        vm.navigateToPhase = function (phaseIndex) {
            var navigate = false;
            if (vm.currentPhaseIndex !== phaseIndex) {
                navigate = true;
            }
            vm.currentPhaseIndex = phaseIndex;
            updateProgressCircles();
            //scrollingService.scrollTo('phase' + phaseIndex, 240, 0, 0);
            vm.currentPhaseHasRequiredDownloads = currentPhaseHasRequiredDownloads();
            vm.currentPhaseHasNotes = currentPhaseHasNotes();
            updateNavigationStates();
            if (navigate) {
                $state.go('workflow.navigator.phase', { workflowId: vm.workflowId, phaseIndex: phaseIndex }).then(function () {
                    $timeout(function () {
                        scrollingService.scrollTo('phaseSectionsContainer', 320, 0, 0);
                    }, 0);
                });
            }
        };

        vm.navigateToNextInProgressPhase = function () {
            var unfinishedPhaseIndices = vm.workflowData.Phases.map(function (phase, index) {
                return (phase.Access.View && !phase.IsRemoved && !(phase.PercentageComplete === 100)) ?
                    index : null;
            }).filter(function (phase) {
                return phase !== null;
            });

            // if (unfinishedPhaseIndices.length === 0) {
            //     notifyService.notify('You have completed this phase and the entire ' +
            //         (vm.workflowData.WorkflowTypeIdentifier || 'project'));
            // }

            var indexToNavigateTo;
            var indexToNavigateTo = unfinishedPhaseIndices.find(function (index) {
                return index >= vm.currentPhaseIndex;
            });

            if (!indexToNavigateTo) {
                indexToNavigateTo = unfinishedPhaseIndices[unfinishedPhaseIndices.length - 1];
            }

            if (indexToNavigateTo) {
                // notifyService.notify('You have completed this phase.');

                $timeout(function () {
                    scrollingService.scrollTo('advanceContainer', 150, 0, 0);
                });
                // $timeout(function () {
                //     vm.navigateToPhaseFromUserAction(indexToNavigateTo + 1);
                // }, 3000);
            }
        }

        vm.navigateForward = function () {
            var phaseIndex = vm.workflowData.Phases.slice(vm.currentPhaseIndex).findIndex(function (phase) {
                return phase.Access.View && !phase.IsRemoved;
            });
            vm.navigateToPhaseFromUserAction(parseInt(vm.currentPhaseIndex, 10) + phaseIndex + 1);
        }

        vm.navigateBackward = function () {
            var phaseIndex = 0;
            var previousPhases = vm.workflowData.Phases.slice(0, vm.currentPhaseIndex - 1);
            for (var i = previousPhases.length - 1; i >= 0; i--) {
                if (previousPhases[i].Access.View && !previousPhases[i].IsRemoved) {
                    phaseIndex = i;
                    break;
                }
            }

            vm.navigateToPhaseFromUserAction(phaseIndex + 1);
        }

        vm.removeRequiredDownload = function (phase, document, downloadIndex) {
            workflowStateService.removeRequiredDownloadFromInformationPart(
                phase,
                document,
                downloadIndex);
            vm.currentPhaseHasRequiredDownloads = currentPhaseHasRequiredDownloads();
        }

        vm.removeInformationPart = function (phase, partIndex) {
            workflowStateService.removeInformationPartFromPhase(phase, partIndex);
        }

        vm.updateDocumentPrompt = function(phase, partIndex) {
            workflowStateService.updateDocumentPrompt(phase, phase.InformationParts[partIndex]);
        }

        vm.deleteUpload = function(phase, documentData, blobIndex) {
            workflowStateService.deleteUpload(phase, documentData, blobIndex);
        }

        vm.syncQuestionSet = function(phase, questionSetData) {
            workflowStateService.syncQuestionSet(phase, questionSetData);
        }

        vm.navigateToPhaseFromUserAction = function (phaseIndex) {
            if (phaseIndex === parseInt(vm.routePhaseIndex, 10)) {
                vm.navigateToPhase(phaseIndex);
            }
            else {
                $state.go('workflow.navigator.phase', { workflowId: vm.workflowId, phaseIndex: phaseIndex });
            }
        }

        vm.topProgressCircleOptions = {
            color: $rootScope.$themes[$rootScope.$currentTheme].accentColor,
            duration: 1400,
            strokeWidth: 3,
            trailWidth: 3,
            easing: 'easeInOut',
            text: {
                autoStyleContainer: false,
                style: {
                    // Text color.
                    // Default: same as stroke color (options.color)
                    color: $rootScope.$themes[$rootScope.$currentTheme].primaryColor,
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    padding: 0,
                    margin: 0,
                    // You can specify styles which will be browser prefixed
                    transform: {
                        prefix: true,
                        value: 'translate(-50%, -50%)'
                    },
                    fontSize: '2em',
                }
            }
        };

        vm.progressCircleOptions = {
            color: $rootScope.$themes[$rootScope.$currentTheme].accentColor,
            duration: 1400,
            strokeWidth: 3,
            trailWidth: 3,
            easing: 'easeInOut',
            text: {
                autoStyleContainer: false,
                style: {
                    // Text color.
                    // Default: same as stroke color (options.color)
                    color: $rootScope.$themes[$rootScope.$currentTheme].primaryColor,
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    padding: 0,
                    margin: 0,
                    // You can specify styles which will be browser prefixed
                    transform: {
                        prefix: true,
                        value: 'translate(-50%, -50%)'
                    },
                    fontSize: '2em',
                }
            }
        };

        vm.smallProgressCircleOptions = {
            color: $rootScope.$themes[$rootScope.$currentTheme].accentColor,
            duration: 1400,
            strokeWidth: 3,
            trailWidth: 3,
            easing: 'easeInOut',
            text: {
                autoStyleContainer: false,
                style: {
                    // Text color.
                    // Default: same as stroke color (options.color)
                    color: $rootScope.$themes[$rootScope.$currentTheme].primaryColor,
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    padding: 0,
                    margin: 0,
                    // You can specify styles which will be browser prefixed
                    transform: {
                        prefix: true,
                        value: 'translate(-50%, -50%)'
                    },
                    fontSize: '1.4em',
                }
            }
        };

        vm.progressCircleOptionsSkipped = {
            color: $rootScope.$themes[$rootScope.$currentTheme].accentColor,
            duration: 1400,
            strokeWidth: 3,
            trailWidth: 3,
            easing: 'easeInOut',
            text: {
                autoStyleContainer: false,
                style: {
                    // Text color.
                    // Default: same as stroke color (options.color)
                    color: $rootScope.$themes[$rootScope.$currentTheme].primaryColor,
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    padding: 0,
                    margin: 0,
                    // You can specify styles which will be browser prefixed
                    transform: {
                        prefix: true,
                        value: 'translate(-50%, -50%)'
                    },
                    fontSize: '1.4em',
                }
            }
        };

        vm.smallProgressCircleOptionsSkipped = {
            color: $rootScope.$themes[$rootScope.$currentTheme].accentColor,
            duration: 1400,
            strokeWidth: 3,
            trailWidth: 3,
            easing: 'easeInOut',
            text: {
                autoStyleContainer: false,
                style: {
                    // Text color.
                    // Default: same as stroke color (options.color)
                    color: $rootScope.$themes[$rootScope.$currentTheme].primaryColor,
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    padding: 0,
                    margin: 0,
                    // You can specify styles which will be browser prefixed
                    transform: {
                        prefix: true,
                        value: 'translate(-50%, -50%)'
                    },
                    fontSize: '.98em',
                }
            }
        };

        $rootScope.$on('phasePercentageCompleteChange',
            function (event, args) {
                if ((args.phaseIndex === vm.routePhaseIndex - 1) && args.percentChanged) {
                    $pbService.animate('topProgressCircle', args.percentageComplete);
                    $pbService.animate('navProgressCircle', args.percentageComplete);
                    $pbService.animate('topProgressCircleSkipped', args.phasePercentageComplete);
                    $pbService.animate('navProgressCircleSkipped', args.phasePercentageComplete);

                    if (args.percentageComplete === 1) {
                        notifyService.notify('You have completed this phase.');
                        vm.navigateToNextInProgressPhase();
                    }
                }
        });

        vm.activateAddQuestionSet = function () {
            vm.isAddingQuestionSet = !vm.isAddingQuestionSet;
            if (vm.isAddingQuestionSet) {
                $timeout(function () {
                    scrollingService.scrollTo('addWorkflowInformationPartQuestionSet', 260, 0, 0);
                    $('#addQuestionSetInput').focus();
                }, 0);
            }
        }

        vm.activateAddDocument = function () {
            vm.isAddingDocument = !vm.isAddingDocument;
            if (vm.isAddingDocument) {
                $timeout(function () {
                    scrollingService.scrollTo('addWorkflowInformationPartDocument', 260, 0, 0);
                    $('#addDocumentInput').focus();
                }, 0);
            }
        }

        vm.activateAddRequiredDownload = function () {
            vm.isAddingRequiredDownload = !vm.isAddingRequiredDownload;
            $timeout(function () {
                scrollingService.scrollTo('addRequiredDownloadForm', 260, 0, 0);
                $('#addRequiredDownloadInput').focus();
            }, 0);
        }

        vm.addInformationPart = function (informationPart) {
            var phase = vm.workflowData.Phases[vm.currentPhaseIndex - 1];
            workflowStateService.addInformationPartToPhase(phase, informationPart);
            vm.setInformationPartPopovers();
        }

        vm.updatePhaseIndex = function () {
            vm.navigateToPhase(vm.routePhaseIndex);
        }

        vm.addToPhaseMenuItems = [
            {
                label: 'Template',
                action: function () {
                    vm.activateAddRequiredDownload();
                },
                iconClass: 'fa fa-file-o'
            },
            {
                label: 'Document',
                action: function () {
                    vm.activateAddDocument();
                },
                iconClass: 'fa fa-file-o'
            },
            {
                label: 'Question Set',
                action: function() {
                    vm.activateAddQuestionSet();
                },
                iconClass: 'fa fa-check-square-o'
            }
        ];

        vm.toggleAddMenuDropdown = function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            vm.isAddMenuOpen = !vm.isAddMenuOpen;
          };

        // $rootScope.$on('duScrollspy:becameActive', function($event, $element, $target) {
        //     var floatingButtonMode = floatingButtonOptions[$element.prop('hash').replace('#', '')];
        //     if (floatingButtonMode) {
        //         vm.floatingButtonData = {
        //             label: floatingButtonMode.label,
        //             show: true,
        //             clickAction: floatingButtonMode.action
        //         }
        //     }
        //     else {
        //         vm.floatingButtonData = {
        //             label: '',
        //             show: false,
        //             clickAction: null
        //         };
        //     }
        // });

        $rootScope.$on('requiredDownloadAdded',
            function () {
                vm.currentPhaseHasRequiredDownloads = true;
            });

        vm.toggleSkipPhase = function skipPhase(phaseIndex) {
            vm.workflowData.Phases[phaseIndex].Status =
                vm.workflowData.Phases[phaseIndex].Status === 'Skipped' ? 'Pending' : 'Skipped';
            workflowStateService.update(vm.workflowData);

            $pbService.animate('topProgressCircle', 0);
            $pbService.animate('navProgressCircle', 0);
            $pbService.animate('topProgressCircleSkipped', 0);
            $pbService.animate('navProgressCircleSkipped', 0);

            if (vm.workflowData.Phases[phaseIndex].Status === 'Skipped' &&
                vm.canNavigateForward) {
                vm.navigateForward();
            }

            notifyService.notify('You have ' +
                (vm.workflowData.Phases[phaseIndex].Status !== 'Skipped' ? 'un' : '') +
                'skipped the phase ' + vm.workflowData.Phases[phaseIndex].Title);
        }

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            // if (vm.stickyElement) {
            //     vm.stickyElement.destroy();
            // }
            if (!toState.name.startsWith('workflow.navigator')) {
                return;
            }

            var arrayPhaseIndex = parseInt(toParams.phaseIndex || 1, 10) - 1;
            if (!vm.workflowData.Phases[arrayPhaseIndex].Access.View) {
                var indexToNavigateTo = vm.workflowData.Phases.indexOf(vm.workflowData.Phases.find(function (phase) {
                    return phase.Access.View;
                }));

                // if (toParams.phaseIndex !== (indexToNavigateTo + 1).toString()) {
                //     notifyService.notify('You do not have access to this phase of the workflow and are being redirected', true);
                // }

                $state.go('workflow.navigator.phase', { workflowId: vm.workflowData.Id.split('/')[1], phaseIndex: indexToNavigateTo + 1 });
            }

            vm.advanceMode = 'roadmap';
            if (vm.workflowData.Phases.length > arrayPhaseIndex + 1) {
                for (var i = arrayPhaseIndex + 1; i < vm.workflowData.Phases.length; i++) {
                    if (vm.workflowData.Phases[i].Access.View && vm.workflowData.Phases[i].Status !== 'Skipped') {
                        vm.advanceMode = 'phase';
                        vm.phaseIndexToAdvanceTo = i;
                        break;
                    }
                }
            }

            vm.routePhaseIndex = arrayPhaseIndex + 1;

            // This trick allows us to take action after the DOM has been rendered
            $timeout(function () {
                $rootScope.$emit('jumpToComment', { path: toParams.path });
                vm.navigateToPhase(vm.routePhaseIndex);
                vm.setInformationPartPopovers();
           });


        });



        vm.advanceToNextPhase = function () {
            if (vm.advanceMode === 'roadmap') {
             $state.go('workflow.roadmap', { workflowId: vm.workflowData.Id.split('/')[1] });
            } else {
             $state.go('workflow.navigator.phase', { workflowId: vm.workflowData.Id.split('/')[1], phaseIndex: vm.phaseIndexToAdvanceTo + 1 });
            }
        }

        vm.toggleWorkflowReorderMode = function () {
            if (!$rootScope.workflowReorderMode) {
                $rootScope.workflowReorderModeToast = toastr.info('You are currently reordering this workflow phase',
                    {
                        timeOut: 0,
                        extendedTimeOut: 0,
                        closeButton: true,
                        closeHtml: "<button>Stop reordering</button>",
                        onHidden: function () {
                            $rootScope.workflowReorderMode = false;
                        }
                    });
            } else {
                if ($rootScope.workflowReorderModeToast) {
                    toastr.clear($rootScope.workflowReorderModeToast);
                    delete $rootScope.workflowReorderModeToast;
                }
            }

            $rootScope.workflowReorderMode = !$rootScope.workflowReorderMode;
        }

        vm.reorderRequiredDownloads = function (requiredDownloadIndex) {
            vm.workflowData.Phases[vm.currentPhaseIndex - 1].RequiredDownloads.splice(requiredDownloadIndex, 1);
            workflowStateService.update(vm.workflowData);
        }

        vm.reorderPhaseInformationParts = function (informationPartIndex) {
            vm.workflowData.Phases[vm.currentPhaseIndex - 1].InformationParts.splice(informationPartIndex, 1);
            workflowStateService.update(vm.workflowData);
        }

        vm.saveSearchChanges = function () {
            workflowStateService.update(vm.workflowData);
        }

        vm.updatePrompt = function () {
            // This trick makes sure the model is updated before we actually send the update
            $timeout(function () {
                workflowStateService.update(vm.workflowData);
            }, 0);
        }

        vm.onPhaseNoteAdded = function (phaseIndex) {
            vm.currentPhaseHasNotes = currentPhaseHasNotes();
        }

        vm.onPhaseNoteRemoved = function (phaseIndex, noteId) {
            var phase = vm.workflowData.Phases[phaseIndex];
            var noteToRemoveIndex = phase.ProjectUnderwritingNotes.map(function (note) {
                return note.NoteId === noteId;
            });

            if (noteToRemoveIndex !== -1) {
                phase.ProjectUnderwritingNotes.splice(noteToRemoveIndex, 1);
            }

            vm.currentPhaseHasNotes = currentPhaseHasNotes();
        }

        $scope.$on('workflowUpdated', function () {
            vm.workflowData = workflowStateService.get();
            setFilteredPhases();
        });
    }

    workflowNavigatorController.$inject = ['$scope', '$rootScope', '$timeout', '$state', '$window', '$log',
        'sessionData', 'entitySearches', 'milestones', 'phaseThumbnails',
        'scrollingService', 'workflowStateService', 'milestoneModalService', 'workflowThumbnailsService',
        'workflowConfigurationDataService', 'notifyService', 'toastr', 'hlStickyStack', '$pbService'];

    angular.module('ecap.workflow').controller('workflowNavigatorController', workflowNavigatorController);
})();
